import { BehaviorSubject, combineLatest } from "rxjs";
import { filter, map } from "rxjs/operators";
import { FiltersAbstractService } from "src/app/common-page-components/classes/filters-abstract-service";
import { ComboStoreComponent, EventAthleteResultsCombo, YesNotCombo } from "src/app/common-page-components/stores/filters-store/filters-store";
import { FiltersAthleteGeneralService } from "../../services/filters-athlete-general.service";
import * as i0 from "@angular/core";
import * as i1 from "../../services/filters-athlete-general.service";
export class AthleteWcupRankingFiltersStageService extends FiltersAbstractService {
    constructor(common_service) {
        super();
        this.common_service = common_service;
        /**
         * Categories combo from general athlete to get the athlete categories.
         *
         * @memberof AthleteWcupRankingFiltersStageService
         */
        this.athleteCategoriesCombo = this.common_service.athleteCategoriesCombo;
        /**
         * Categories combo from general athlete to get the athlete categories.
         *
         * @memberof AthleteWcupRankingFiltersStageService
         */
        this.categoriesCombo = new ComboStoreComponent('Categories: ', 'CatName', 'wcrup-category-combo', undefined, undefined, undefined, undefined);
        /**
         * A lock to only dispatch the events on the method getDataStreamWithFilters when categories are ready and filtered.
         *
         * @memberof AthleteWcupRankingFiltersFinalsService
         */
        this.categoriesReady = new BehaviorSubject(false);
        /**
         * Event type combo.
         *
         * @memberof AthleteWcupRankingFiltersStageService
         */
        this.eventTypeCombo = new EventAthleteResultsCombo("Event:", "event-results-combo");
        /**
         * Podiums only filter.
         *
         * @memberof AthleteWcupRankingFiltersService
         */
        this.podiumsOnly = new YesNotCombo("Podiums", "wcup-podiums-only");
        /**
         * The filters of the BootstrapAthleteWcupRankingComponent page.
         *
         * @memberof BootstrapAthleteWcupRankingComponent
         */
        this.filtersType = [
            this.categoriesCombo.filterInfo,
            this.eventTypeCombo.filterInfo,
            this.podiumsOnly.filterInfo
        ];
        this.eventTypeCombo.setData([{ Value: 0, Name: 'All' }].concat(...(this.eventTypeCombo['extraOptions']).map(value => value.item).filter(value => ['Individual', 'Mixed Team', 'Team', 'All'].indexOf(value.Name) != -1)), { Name: "Individual", Value: 0 });
        this.eventTypeCombo.setSelected({ Name: "Individual", Value: 0 });
        const categoriesToSet = [].concat(...this.athleteCategoriesCombo.data.filter(value => ['RM', 'RW', 'CM', 'CW'].indexOf(value.Cat) != -1));
        this.categoriesCombo.setData(categoriesToSet, categoriesToSet[0]);
    }
    /**
     * {@inheritdoc}
     *
     * @return {*}  {void}
     * @memberof AthleteWcupRankingFiltersStageService
     */
    generateDefaultValues() {
        return;
    }
    /**
     *
     * @inheritdoc
     * @returns {import("rxjs").Observable<any>}
     * @memberof AthleteWcupRankingFiltersService
     */
    getDataStreamWithFilters() {
        return combineLatest([this.categoriesReady.asObservable(), this.categoriesCombo.comboData, this.eventTypeCombo.comboData, this.podiumsOnly.comboData]).pipe(filter(a => a[0] === true), map(a => {
            return [a[1], a[2], a[3]];
        }));
    }
}
AthleteWcupRankingFiltersStageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AthleteWcupRankingFiltersStageService_Factory() { return new AthleteWcupRankingFiltersStageService(i0.ɵɵinject(i1.FiltersAthleteGeneralService)); }, token: AthleteWcupRankingFiltersStageService, providedIn: "root" });
